
export class MensajeDto {
	titulo: string;
	cuerpo: string;
	url: string;	
}
